export function isClientManagerRole(role) {
  return Number(role) === 5
}

export function isClientPortalReportRole(role) {
  const id = Number(role)
  return id === 3 || id === 5
}

/** Админ всегда; менеджер — только при can_block_cards. */
export function canManageCardBlock(userRole, myUser) {
  const role = Number(userRole)
  if (role === 1) return true
  if (role === 2) return !!myUser?.can_block_cards
  return false
}
